import { AppModule } from '@app/types';

export const AuditModule: AppModule = {
  id: 'audit',
  // icon: <AuditIco />,
  title: 'Audit',
  basePath: 'audit',
};
